module.exports = __webpack_public_path__ + "files/ab79d332df2bfd203b0dbd0c0f56f9c8.png";